// NOTE this const exists both here and in the API. It must remain consistent between both sources
export const LoginButtonSettings = {
  Default: 'Default',
  EnableCustomerLoginOnly: 'EnableCustomerLoginOnly',
  EnableEmployeeLoginOnly: 'EnableEmployeeLoginOnly',
  EnableDbLoginOnly: 'EnableDbLoginOnly',
};
